import { render, staticRenderFns } from "./NotificationSettingsSwitch.vue?vue&type=template&id=552c0d2f&"
import script from "./NotificationSettingsSwitch.vue?vue&type=script&lang=ts&"
export * from "./NotificationSettingsSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
